import supabaseClient from '@/api/supabaseClient.ts';
import { FunctionsHttpError, SupabaseClient } from '@supabase/supabase-js';
import { useQuery } from '@tanstack/react-query';
import { CallMessage } from '@/types/models/CallMessage';
import { GetCallMessagesRequest } from '@/types/request/GetCallMessagesRequest';

const useCallMessages = ({ callLogId, locale = 'en_US' }: GetCallMessagesRequest) => {
  const client = supabaseClient;
  const queryKey = ['call_messages', callLogId, locale];

  const queryFn = async () => {
    return getCallMessages(client, { callLogId, locale });
  };

  return useQuery({
    queryKey,
    queryFn,
    enabled: !!callLogId,
    staleTime: 1000 * 60 * 5,
  });
};

export default useCallMessages;

async function getCallMessages(client: SupabaseClient, request: GetCallMessagesRequest): Promise<CallMessage[]> {
  if (!request.callLogId) {
    throw new Error('Call log ID is required');
  }

  const { data, error } = await client.functions.invoke('get-call-messages', {
    body: { ...request },
  });

  if (error && error instanceof FunctionsHttpError) {
    const errorMessage = await error.context.json();

    if (errorMessage.error) {
      throw new Error(errorMessage.error);
    }

    throw new Error(error.message);
  }

  return data as CallMessage[];
}
